import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
